<template>
  <div id="app">
    <div id="main-container" class="container container-fluid">
        <div class="row header-content row-lg-eq-height">
          <div class="header">
            <img src="/osiris/static/img/logo_osiris_cores.png" class="logo">
            <img src="/osiris/static/img/logo_ces.png" class="logo-ces">
          </div>
        </div>
        <div class="row main-content row-lg-eq-height">
          <div class="content">
            <router-view></router-view>
          </div>
        </div>
        <div class="row outside-content row-lg-eq-height">
          <marquee>
            <a :href="sig.rdfs_seeAlso" v-for="sig in sigimera" :key="sig._id">
              {{ sig.dc_title }}&nbsp;&nbsp;&nbsp;| 
            </a>
            <a :href="hr.id" v-for="hr in hResponse" :key="hr.id">
              {{ hr.label }}&nbsp;&nbsp;&nbsp;| 
            </a>
            <a :href="rw.href" v-for="rw in reliefWeb" :key="rw.id">
              {{ rw.fields.name }}&nbsp;&nbsp;&nbsp;| 
            </a>
          </marquee>
        </div>
        <div class="row footer-content row-lg-eq-height">
          <div class="footer">
            <div class="footer-left">
              <strong>Observatório do Risco OSIRIS</strong><br/>
              Centro de Estudos Sociais (CES)<br/>
              Universidade de Coimbra<br/><br/>  
            </div>
            <div class="footer-right">
              Colégio de S. Jerónimo<br/>
              Apartado 3087<br/>
              3001-401 Coimbra<br/>
              PORTUGAL<br/>
              Telefone: +351239855590<br/>
              E-mail: osiris@ces.uc.pt<br/>
              www.ces.uc.pt/osiris
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  data () {
    return {
      content: '',
      reliefWeb: [],
      hResponse: [],
      sigimera: []
    }
  },
  computed: {
  },
  mounted () {
    axios.get('https://api.reliefweb.int/v1/disasters?appname=apidoc&limit=10')
    .then(response => {
      this.reliefWeb = response.data.data
    })
   .catch(error => {
     console.log(error.data.error.message)
   })

    axios.get('https://www.humanitarianresponse.info/api/v1.0/disasters?filter[status]=current')
    .then(response => {
      this.hResponse = response.data.data
    })
   .catch(error => {
     console.log(error.data.error.message)
   })

    axios.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-sigimera')
    .then(response => {
      this.sigimera = response.data
    })
   .catch(error => {
     console.log(error)
   })
  }
}
</script>

<style>
*{
  box-sizing: border-box;
}

html,body,.col-md-12,.row {
  height:100%;
}
body{
  padding:0px;
  margin:0px;
  font-family: pt-serif,sans-serif;
  -webkit-overflow-scrolling: touch;
  line-height: 1.6;
  background-color: #EEE;
  color:#333333;
}

#app {
}

.main-container{
  width: 1190px;
}

a, a.visited{
  color:rgb(255,0,0);
  text-decoration: none;
}

a:hover{
  text-decoration: underline;
}

.header{
  height: 167px;
}

.header .logo{
  float:left;
  margin:10px 10px;
  height: 120px;
}

.header .logo-ces{
  float:right;
  margin:10px;
  width: 150px;
}

.leftbar{
  padding:0px;
  margin:0px;
}

.leftbar ul.nav{
  list-style-type: none;
  padding:0px;
  margin-top: 30px;
  width: 100%;
}

.leftbar ul.nav li{
  text-align: left;
  width: 100%;  
  cursor: pointer;
}

.leftbar ul.nav li a{
    width: 100%;
    color:#222222;
    font-size: 1.2em;
    padding: 10px 50px;
}

.leftbar ul.nav li:hover a{
    background-color: rgba(0,0,0,0);
    text-decoration: underline;
    color:rgb(255,0,0);
}

.center{
  width: 50%;
  border-left: 1px solid #eee;
  float: left;
  padding:20px;
  font-size: 1.2em;
  line-height: 1.5em;
}

.center .pagetitle{
  text-align: left;
  padding:10px;
  font-size:25px;
  font-weight: bold;
  color:rgb(255,0,0);
}

.center .center-content{
  margin:10px;
}

.content{
  width: 100%;
  display: inline-block;
  clear: both;
}

.rightbar{
  border-left: 1px solid #eee;
  margin-top: 70px;
  padding: 5px 20px 20px 20px;
  font-size:1.1em;
  height: 100%;
  display: table-cell;
}

.footer{
  padding-top: 3.125rem;
  padding-bottom: 3.125rem;
  background-color: #383d42;
  color: #fff;
  line-height: 2rem;
  display: inline-block;
  width: 100%;
  margin-top: 10px;
}

.footer-left{
  box-sizing: border-box;
  width: 50%;
  text-align: right;
  float:left;
  padding-right: 5px;
}

.footer-right{
  box-sizing: border-box;
  float: right;
  width: 50%;
  text-align: left;
  padding-left: 5px;
}

.main-content{
  background-color: #FFF;
}

.itemtabelasublinhado{
  padding-bottom: 15px;
  padding-top: 15px;
  border-bottom: 1px solid #eee;
}

.itemtabelasublinhado .titulo_sub{
  font-weight: bold;
}

.outside-content{
  padding: 5px;
  margin-top: 10px;
  background-color: #ffffff; 
}

.outside-content a{
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// App.vue?c559504a